import { getRequest } from "../../app/request";
import { failurePut } from "../../app/failurePut";
import { getTransactionsAction, getTransactionsFailure, getTransactionsSuccess } from "./transactionsReducer";
import { call, put, takeEvery } from "redux-saga/effects";

export function* getTransactionsSaga({ payload }) {
    try {
        const data = yield call(getRequest, '/users/transactions', payload);
        yield put(getTransactionsSuccess(data));
    } catch (e) {
        yield call(failurePut, e, getTransactionsFailure);
    }
}

export function* transactionsSagas() {
    yield takeEvery(getTransactionsAction, getTransactionsSaga);
}
